import { RouterMap } from '../../types';

export const routeMap: RouterMap = new Map();

routeMap.set('/OrderManage', {
  name: 'OrderManage',
  meta: {
    hideChildrenInMenu: true,
    nav: [
      { id: '1', title: '未完成' },
      { id: '2', title: '已完工' },
      { id: '3', title: '已退单/已取消' },
      { id: '0', title: '所有' },
    ],
  },
});
